export const LogoMark = ({ className = "h-9 w-9", tone = "dark" }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" aria-hidden="true">
    <path
      d="M32 3C32 3 9 27.5 9 42a23 23 0 0 0 46 0C55 27.5 32 3 32 3Z"
      fill={tone === "dark" ? "#0F382C" : "#FDFBF7"}
    />
    <path
      d="M21.5 45 32 19.5 42.5 45M26 37h12"
      stroke={tone === "dark" ? "#FDFBF7" : "#0F382C"}
      strokeWidth="3.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
